// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-142e07e2]{padding:2.133vw 6.4vw 21.333vw}.content .title[data-v-142e07e2]{font-size:4.8vw;font-weight:700;margin:3.2vw 0}", ""]);
// Exports
module.exports = exports;
